import React, { Component } from 'react'
import funciones from '../../middleware/funciones';
import { Button, Table, Jumbotron, Container, Row, Col, Form } from 'react-bootstrap';
// ;
import config from '../../config';
import Spinner from '../subcomponent/spinner';
import { CSVLink } from "react-csv";

export class reporteAcuse extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;

        this.state = {
            resoluciones: [],
            documentos: [],
            loading: false,
            empresa: currentCompany,
            tipo: currentUserType,
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            numero_inicial: "",
            numero_final: "",
            tipo_documento: ""
        };
    };

    componentDidMount() {
        const { empresa } = this.state
        const { tipo } = this.state
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': empresa,
                'tipo': tipo,
            }
        };
        fetch(config.servBackEnd + '/resoluciones/', datasend)
            .then(res => res.json())
            .then((data) => {
                this.setState({ resoluciones: data });

            })
            .catch((error) => console.error(error))
    };

    updateInfo = () => {
        this.setState({ loading: true });
        const { empresa } = this.state
        const { tipo } = this.state
        const busqueda = {
            fecha_ini: this.state.fecha_inicial,
            fecha_fin: this.state.fecha_final,
            numero_inicial: this.state.numero_inicial,
            numero_final: this.state.numero_final,
            tipo_doc: this.state.tipo_documento
        };

        const datasend = {
            method: 'POST',
            body: JSON.stringify(busqueda),
            headers: {
                'Content-Type': 'application/json',
                'empresa': empresa,
                'tipo': tipo,
            }
        };
        fetch(config.servBackEnd + '/documents/receive', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const datos = data.data;
                    this.setState({ documentos: datos, loading: false });
                    this.reconteo();
                } else {
                    if (data.code === "0000") this.setState({ documentos: [], loading: false });
                }
            })
            .catch((error) => console.error(error))
    };

    render() {
        const { loading } = this.state;
        const { documentos } = this.state;
        const { resoluciones } = this.state;
        return (
            <div>

                <Jumbotron className="Jumbotron">
                    <h2>Informe de acuse de facturas</h2>
                </Jumbotron>
                <Container fluid>
                    <Row className="justify-content-md-center" >
                        <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={this.state.fecha_inicial} />
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
                        <Col className="mb-2" xs={7} lg={2}>
                            <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={this.state.fecha_final} />
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>TIPO</Col>
                        <Col className="mb-2" xs={7} lg={1}>
                            <Form.Control as="select" onChange={e => this.setState({ tipo_documento: e.target.value })} value={this.state.tipo_documento} >
                                <option value=""></option>
                                {
                                    resoluciones.map((resoluion, i) => {
                                        return <option key={'td' + i} value={resoluion.PREFIJO}>{resoluion.PREFIJO}</option>;
                                    })
                                }
                            </Form.Control>
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>NUMERO INICIAL</Col>
                        <Col className="mb-2" xs={7} lg={1}>
                            <Form.Control type="number" onChange={e => this.setState({ numero_inicial: e.target.value })} value={this.state.numero_inicial} />
                        </Col>
                        <Col className="mb-2" xs={5} lg={1}>NUMERO FINAL</Col>
                        <Col className="mb-2" xs={7} lg={1}>
                            <Form.Control type="number" onChange={e => this.setState({ numero_final: e.target.value })} value={this.state.numero_final} />
                        </Col>
                        <Col className="mb-2" >
                            <Button id="actualizar" className="m-3" name="actualizar" onClick={this.updateInfo}  >Buscar Documentos </Button>
                            <CSVLink data={documentos} filename={"INVENTARIO.csv"} separator={";"}>
                                <Button disabled={documentos.length === 0} variant="success">Descargar Reporte</Button>
                            </CSVLink>
                        </Col>
                    </Row>
                </Container>
                <Table hover bordered responsive size="sm" className="table">
                    <thead>
                        <tr>
                            <th>Tipo Documento</th>
                            <th>Numero Documento</th>
                            <th>Nombre Cliente</th>
                            <th>Estado</th>
                            <th>Observaciones Acuse</th>
                            <th>Fecha Generacion</th>
                            <th>Fecha Procesado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(!loading && documentos.length > 0) &&
                            documentos.map((currentData, index) => {
                                return (<tr key={index + "d0"}>
                                    <td>{currentData.TIPO_DOCUMENTO}</td>
                                    <td>{currentData.NUMERO_DOCUMENTO}</td>
                                    <td>{currentData.NOMBRE_CLIENTE}</td>
                                    <td>{currentData.ESTADO}</td>
                                    <td>{currentData.OBSERVACION_ACUSE}</td>
                                    <td>{funciones.formatDate(currentData.FECHA_GENERACION)}</td>
                                    <td>{funciones.formatDate(currentData.FECHA_PROCESADO)}</td>
                                </tr>);
                            })
                        }
                        {(!loading && documentos.length === 0) &&
                            <tr>
                                <td colSpan="5"> CONSULTA SIN RESULTADOS </td>
                            </tr>
                        }
                    </tbody>
                </Table>
                {loading && <Spinner loading={loading} />}
            </div>
        )
    }
}

export default reporteAcuse



// WEBPACK FOOTER //
// ./src/components/factlectronica/reporteAcuse.jsx